import { AmLyrics } from './AmLyrics.js';

window.customElements.define('am-lyrics', AmLyrics);
